import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const ContactSummaryFormDE = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['email', 'phone'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;
  const emailField = s.email.fields.find(({ name }) => name === 'email');
  const emailLabel = translate(emailField?.label);

  const mobileField = s.phone.fields.find(({ name }) => name === 'mobile');
  const mobileLabel = translate(mobileField?.label);

  const phoneField = s.phone.fields.find(({ name }) => name === 'phone');
  const phoneLabel = translate(phoneField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-contact'}>
      <h2>{translate(s.dataSummary.titles?.contact)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{emailLabel}</div>
        <div className={'value'}>
          {getFieldValue('email')}
          {
            <div style={{ display: 'none' }}>
              <EditDataField field={emailField!} slideId={'email'} />
            </div>
          }
        </div>

        <div className={'label'}>{mobileLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('mobile')}
          {editMode && <EditDataField field={mobileField!} slideId={'phone'} />}
        </div>
        <div className={'label'}>{phoneLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('phone')}
          {editMode && <EditDataField field={phoneField!} slideId={'phone'} />}
        </div>
      </div>
    </div>
  );
};
